/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file finish reducer for async state
 * @author Roland Scott
 * @module react-async-hook\internal\state\reducers\finish
 */

import { IAsyncState } from "../types";

/**
 * Mark the specified async execution as finished.
 * @param prevState The old async state
 * @param id the ID of the execution to finish
 * @param result the result (if any) returned during execution of the async
 * @param error the error (if any) returned during execution of the async
 * @return The new async state
 */
export function finish(prevState: IAsyncState, id: number, result: any, error: any): IAsyncState {
	if (!id) {
		throw Error("Execution id is not defined.");
	}
	if (!prevState.executions[id]) {
		throw Error(`Execution id ${id} does not exist.`);
	}
	return {
		...prevState,
		executions: {
			...prevState.executions,
			[id]: {
				...prevState.executions[id],
				inFlight: false,
				complete: true,
				error,
				result,
			},
		},
	};
}
